import { claimApi } from '@/main/api';
import useAsyncModalConfirm from '@/main/components/shared/asyncModalConfirm/asyncModalConfirm';
import { useThreeDotsQuoteContext } from '@/main/components/shared/threeDotsQuote/contex';
import { Controls } from '@/main/services/constants/constantsControl';
import {
  getTranslateByKey,
  isShowControlByElementId
} from '@/main/services/utils';
import { MenuItem } from '@mui/material';
import { toast } from 'react-toastify';

interface IThreeDotsQuoteSendUpdates {
  guidClaim: string;
  guidQuote: string;
  isAwaitingRelease: boolean;
}

function ThreeDotsQuoteSendUpdates({
  guidClaim,
  guidQuote,
  isAwaitingRelease
}: Readonly<IThreeDotsQuoteSendUpdates>) {
  const { setAnchorEl } = useThreeDotsQuoteContext();

  const [getConfirmationSendUpdates, ModalConfirmationSendUpdates] =
    useAsyncModalConfirm();

  const showSendUpdates =
    isShowControlByElementId(Controls.IdSendUpdatesViewOrder) &&
    isAwaitingRelease;

  async function handleClickSendUpdates() {
    const confirmed = await getConfirmationSendUpdates(
      getTranslateByKey('information.confirmSendUpdates')
    );
    if (!confirmed) return;

    setAnchorEl(null);

    claimApi.addSendUpdateQueue({ guidClaim, guidQuote }).then(res => {
      if (res.data) {
        toast.success(
          getTranslateByKey(
            'procurementHistoricalAction.SendUpdatesManuallyQueued'
          )
        );
      }
    });
  }

  if (!showSendUpdates) return;

  return (
    <>
      <MenuItem
        id={`id-option-button-sendUpdates`}
        onClick={handleClickSendUpdates}>
        {getTranslateByKey('integrationInterface.sendUpdates')}
      </MenuItem>
      <ModalConfirmationSendUpdates />
    </>
  );
}

export { ThreeDotsQuoteSendUpdates };

